import { EM_DASH } from '~/common/constants/unicode';
import { Box } from '~/eds/src/components/Box/Box';
import { Select } from '~/eds/src/components/Select/Select';

import { booleanOptions, capitalizeString } from '../../helpers';
import { BaseFieldProps } from './fieldTypes';

export const BooleanField = ({
  field,
  editMode,
  editData,
  onEditDataChange,
  isWssField,
}: BaseFieldProps) => {
  if (editMode) {
    const value = editData[field.id];

    return (
      <Box flex="1">
        <Select
          name={field.name}
          value={typeof value === 'boolean' ? value : null}
          options={booleanOptions}
          onChange={(newValue: boolean | null) =>
            onEditDataChange(field.id, newValue)
          }
          disabled={!field.is_editable || isWssField(field)}
          isClearable={field.is_nullable}
          isSearchable={false}
          isMulti={false}
        />
      </Box>
    );
  }

  if (field.value && !Array.isArray(field.value) && field.value.display_value) {
    return capitalizeString(String(field.value.display_value));
  }

  return EM_DASH;
};
